import { EtsyPersonalizationPlugins, ShopifyPersonalizationPlugins } from 'editor/src/store/plugins/constants';
import { Plugin, PluginName } from 'editor/src/store/plugins/types';

export function getRelevantGlobalPlugins(globalPlugins: PluginName[], plugins: Plugin[]): PluginName[] {
  const activePluginNames = plugins.map(({ name }) => name);
  let updatedGlobalPlugins = globalPlugins.filter((plugin) => activePluginNames.includes(plugin));

  if (!updatedGlobalPlugins.length) {
    const etsyPersonalizationPlugins = EtsyPersonalizationPlugins.filter((plugin) =>
      activePluginNames.includes(plugin),
    );
    const shopifyPersonalizationPlugins = ShopifyPersonalizationPlugins.filter((plugin) =>
      activePluginNames.includes(plugin),
    );

    if (etsyPersonalizationPlugins.length) {
      updatedGlobalPlugins = [PluginName.emailWorkflowPersonalization];
    } else if (shopifyPersonalizationPlugins.length) {
      updatedGlobalPlugins = [PluginName.shopifyPersonalizationInEditor];
    }
  }

  return updatedGlobalPlugins;
}
